module.exports = __webpack_public_path__ + "static/media/goto_shop_mobile.7db19488.svg";